import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {Row, Col, Button} from 'react-bootstrap';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormCodeEditor from 'components/forms/FormCodeEditor';
import StylesVariableFormElement from 'components/layout/whiteLabel/StylesVariableFormElement';

import Loader from 'components/layout/Loader';
import List from 'components/List';
import FormFolder from "components/forms/FormFolder";
import {changeUploadContext, fileUploadHelper, resetUploadContext} from "actions/UploadActions";
import {addNotification} from "actions/NotificationsActions";
import {formStatusDispatchHelper} from "actions/FormStatusActions";
import {blockForm, releaseForm} from "actions/ActiveFormsActions";

class WhiteLabelTheme extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
    };
  }

  updateCss = code => {
    this.updateEntity('customCss', code);
  };

  import = () => {
    const {files} = this.state;
    this.manualUpload(files);
  }

  updateContext = () => {
    const { clientId } = this.props;
    this.props.updateUploadContext({
      type: 'whitelabel_fonts',
      uploadLink: '/api/whitelabels/fonts.json',
    });
  }

  manualUpload = files => {
   {
      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        this.props.uploadFile(file, this.props.upload.context.uploadLink, this.props.upload.context.data);
      }
    }
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      changeEntity,
      disabled,
      inModal,
      stylesVariables,
    } = this.props;

    return (
      <div class="clearfix">
        {entityLoaded && (
          <div>
            <Row>
              <Col xs={12} md={inModal ? 12 : 7}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p className="form-group-title">Less builder</p>
                    <div class="form-group-attached">
                      <FormCodeEditor
                        label={messages.custom_less}
                        name="customCss"
                        value={entity.getCustomCss()}
                        meta={entity.getCustomCssMetaInformation()}
                        validation={entity.getCustomCssValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={inModal ? 12 : 5}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p className="form-group-title">Less variables</p>
                    <List listName="stylesVariables" url="/api/stylesvariables.json" list={stylesVariables}>
                      {stylesVariables.pending ? (
                        <Loader />
                      ) : (
                        <div class="form-group-attached">
                          {stylesVariables.data.list.map(stylesVariable => {
                            return (
                              <StylesVariableFormElement
                                key={stylesVariable.id}
                                stylesVariable={stylesVariable}
                                entity={entity}
                                changeEntity={changeEntity}
                                disabled={disabled}
                              />
                            );
                          })}
                        </div>
                      )}
                    </List>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="padding-60">
              <p className="form-group-title">{messages.custom_font}</p>
              <FormFolder
                label={messages.custom_font_folder}
                name="file"
                onChange={(fieldName, files) => {
                  this.setState({ files: files });
                  this.updateContext();
                }}
              />
              <Button bsStyle="info" onClick={this.import}><i className={'fas ' + (this.props.upload.isUploading ? 'fa-circle-notch fa-spin' : 'fa-upload')}/> Upload</Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
WhiteLabelTheme.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    stylesVariables: state.list.stylesVariables,
    upload: state.upload,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateUploadContext: newContext => {
      dispatch(changeUploadContext(newContext));
    },
    doResetUploadContext: () => {
      dispatch(resetUploadContext());
    },
    uploadFile: fileUploadHelper(dispatch),
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(WhiteLabelTheme));
